import React, { useEffect, useRef } from "react";

/**
 * Floating Add Menu (SafetyCulture-style)
 */
export default function AddFloatingMenu({
  visible,
  position,
  onAddQuestion,
  onAddSection,
  isMobile = false,
}) {
  const menuRef = useRef(null);

  // Smooth SC-style appear animation
  useEffect(() => {
    if (!menuRef.current) return;

    if (visible) {
      menuRef.current.style.opacity = "1";
      menuRef.current.style.transform = "translateX(0) scale(1)";
    } else {
      menuRef.current.style.opacity = "0";
      menuRef.current.style.transform = "translateX(-4px) scale(0.98)";
    }
  }, [visible]);

  if (!visible || !position) return null;

  const viewportWidth =
    typeof window !== "undefined" && window.innerWidth
      ? window.innerWidth
      : 1024;

  const isNarrow = viewportWidth < 1024;
  const menuWidth = isNarrow ? 160 : 150;
  const gap = 12;

  let left = position.left;
  const top = position.top;

  // Clamp so the menu never goes fully off-screen on mobile/desktop
  if (left < gap) left = gap;
  if (left + menuWidth + gap > viewportWidth) {
    left = viewportWidth - menuWidth - gap;
  }

  return (
    <div
      ref={menuRef}
      className="fixed z-[200] select-none"
      style={{
        top,
        left,
        transform: "translateX(-4px) scale(0.98)",
        opacity: 0,
        transition:
          "opacity 120ms cubic-bezier(0.16,1,0.3,1), transform 120ms cubic-bezier(0.16,1,0.3,1)",
      }}
    >
      <div
        className="bg-white border border-gray-300 shadow-sm rounded-md flex flex-col py-1"
        style={{
          width: 130,
          filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.06))",
        }}
      >
        {/* Add Question */}
        <button
          onClick={onAddQuestion}
          className="flex items-center gap-1 px-2 py-1.5 text-xs hover:bg-gray-100 rounded cursor-pointer"
        >
          <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 text-[10px] leading-none">
            +
          </span>
          <span>Add question</span>
        </button>

        {/* Add Section */}
        <button
          onClick={onAddSection}
          className="flex items-center gap-1 px-2 py-1.5 text-xs hover:bg-gray-100 rounded cursor-pointer"
        >
          <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-gray-400 text-[10px] leading-none">
            +
          </span>
          <span>Add section</span>
        </button>
      </div>
    </div>
  );
}
